<header class="bciti-dialog__header">
    <div class="bciti-dialog__title">
      {{ 'pages.user-cards.family.create.address.heading' | translate }}
    </div>
    <button class="bciti-dialog__close-button" (click)="closeDialog()">
      <span  class="icon icon-close"></span>
    </button>
  </header>
  <div class="bciti-dialog__content">
    <div
      class="bciti-dialog__search"
      [ngClass]="{ 'has-results': hasResults }"
    >
      <form [formGroup]="geoIdSearchQueryForm">
        <app-form-input
            label="{{ 'pages.user-cards.family.create.address.label' | translate }} *"
            placeholder="{{ 'common.geoid.queryPlaceholder' | translate }}"
            formControlName="query"
            data-cy="query">
        </app-form-input>
      </form>
      <footer>
        <button [disabled]="loading"
          class="bciti-button bciti-button--blue bciti-button--full-width" 
          (click)="querySearch()">
          <span *ngIf="!loading || hasResults">{{ 'common.geoid.searchButton' | translate }}</span>
          <mat-spinner *ngIf="loading && !hasResults" diameter="20" class="block-center"></mat-spinner>
        </button>
      </footer>
    </div>
    <div class="bciti-dialog__results" *ngIf="hasResults">
      <div *ngIf="loading" class="loading-spinner-wrap view">
        <mat-progress-spinner
          class="block-center"
          mode="indeterminate"
          diameter="30">
        </mat-progress-spinner>
      </div>
      <form [formGroup]="geoIdAddressForm" *ngIf="!loading">
        <app-form-selection-list
          [data]="forceSearchUsed ? listDataForceSearch : listData"
          [initSelected]="true"
          formControlName="address"
        ></app-form-selection-list>
      </form>
    </div>
  </div>
  <footer class="bciti-dialog__footer" *ngIf="hasResults">
    <button 
      class="bciti-button bciti-button--blue bciti-button--full-width"
      (click)="closeDialog()"
      [disabled]="!address.value"
    >
      <span>{{ 'pages.user-cards.common.button.save' | translate }}</span>
    </button>
  </footer>
  